import { useDispatch, useSelector } from 'react-redux'

import PageLevelMessage from '@/components/PageLevelMessage'
import TermsOfPurchaseLink from '@/components/TermsOfPurchaseLink'
import { actions as cartActions } from '@/reducers/cart'
import { updateTermsAcceptance } from '@/reducers/cart/asyncActions'
import { translate } from '@/utils/translations'

const TermsCheckbox = () => {
  const dispatch = useDispatch()
  const requiresTermsAcceptance = useSelector(
    state => state.currentRegion.requiresTermsAcceptance
  )

  const canCheckout = useSelector(
    state => state.cart.canCheckout
  )

  const onChange = e => {
    const isChecked = e.target.checked

    if (canCheckout) handleTerms(isChecked)
  }

  const handleTerms = isChecked => {
    if (isChecked) {
      dispatch(updateTermsAcceptance())
    } else {
      dispatch(cartActions.onTermsUnchecked())
    }
  }

  return (
    <If condition={requiresTermsAcceptance}>
      <div className='accept-terms-checkbox u-push--bottom u-push-half--top'>
        <input
          data-testid='cart-terms-checkbox'
          id='terms-checkbox'
          name='agree-terms-checkbox'
          onChange={onChange}
          type='checkbox'
        />
        <label
          className='acceptance-text u-push-half--left'
          htmlFor='terms-checkbox'
        >
          <span> {translate('common.accept')}{' '}</span>
          <TermsOfPurchaseLink />
        </label>
      </div>
      <PageLevelMessage />
    </If>
  )
}

export default TermsCheckbox
